import client from "./client";

const base = "/v1/purchase/supplier-payables";

export const listDues = async (params) => (await client.get(base, { params })).data;
export const duesSummary = async () => (await client.get(`${base}/summary`)).data;
export const dueDetails = async (id) => (await client.get(`${base}/${id}`)).data;

export const requestApproval = async (id, cashbox_id) =>
  (await client.post(`${base}/${id}/request-approval`, { cashbox_id })).data;

export const approveDue = async (id, note = "") =>
  (await client.post(`${base}/${id}/approve`, { note })).data;

export const rejectDue = async (id, reason) =>
  (await client.post(`${base}/${id}/reject`, { reason })).data;

// Public (no auth) — supplier confirmation
export const viewPaymentLink = async (token) =>
  (await client.get(`/pc/${token}`)).data;

export const confirmPayment = async (token, signature_png, signed_by_name) =>
  (await client.post(`/pc/${token}`, { signature_png, signed_by_name, agreed: true })).data;
